import React from 'react';
import { useControlSpec } from '../contexts/ControlSpecContext';
import { ChevronRight, Check } from 'lucide-react';

const TestStepsPreview = ({ onViewDetails }) => {
    const { controlSpec, changeLog } = useControlSpec();

    if (!controlSpec) {
        return null;
    }

    const isStepChanged = (stepNumber) => {
        return changeLog.some(change =>
            change.includes(`step ${stepNumber}`) ||
            change.includes(`Step ${stepNumber}`)
        );
    };

    return (
        <div className="bg-white rounded-lg shadow border border-gray-200 p-4 mb-4">
            <div className="flex justify-between items-center mb-3">
                <div>
                    <h3 className="font-semibold text-gray-900">{controlSpec.control_title}</h3>
                    <p className="text-xs text-gray-500 mt-1">{controlSpec.test_steps?.length || 0} test steps</p>
                </div>
                <button
                    onClick={onViewDetails}
                    className="text-sm text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1"
                >
                    View Details
                    <ChevronRight className="h-4 w-4" />
                </button>
            </div>

            {/* Simplified Test Steps */}
            <div className="space-y-2">
                {controlSpec.test_steps?.map(step => (
                    <div
                        key={step.step_number}
                        className={`p-3 rounded transition-all ${isStepChanged(step.step_number)
                                ? 'bg-yellow-50 border-l-4 border-yellow-400 animate-pulse shadow-sm'
                                : 'bg-gray-50 border-l-4 border-transparent'
                            }`}
                    >
                        <div className="flex items-start gap-2">
                            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium">
                                {step.step_number}
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-sm text-gray-900">{step.summary || step.description?.substring(0, 100) + '...'}</p>
                                <div className="mt-1 flex items-center gap-3 text-xs text-gray-500">
                                    <span className="flex items-center gap-1">
                                        👤 {step.responsible_party}
                                    </span>
                                    <span className="flex items-center gap-1">
                                        🔍 {step.audit_procedure}
                                    </span>
                                    {(step.test_attributes?.length ?? 0) > 0 && (
                                        <span
                                            className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800"
                                            title={step.test_attributes.map(a => a.label || a.key).join(', ')}
                                        >
                                            {step.test_attributes.length} attribute{step.test_attributes.length === 1 ? '' : 's'}
                                            {step.test_attributes.filter(a => a.required !== false).length > 0 &&
                                                ` · ${step.test_attributes.filter(a => a.required !== false).length} required`}
                                        </span>
                                    )}
                                    {isStepChanged(step.step_number) && (
                                        <span className="bg-yellow-400 text-yellow-900 px-2 py-0.5 rounded font-medium flex items-center gap-1">
                                            <Check className="h-3 w-3" />
                                            Updated
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TestStepsPreview;
